<template>
  <v-app-bar
    class="header"
    hide-on-scroll
    elevate-on-scroll
    scroll-threshold="100"
    color="white"
    height="88px"
    app
  >
    <v-container class="py-0">
      <v-sheet
        width="100%"
        height="100%"
        color="transparent"
        class="d-flex justify-space-between align-center"
      >
        <div class="d-flex align-center mt-n4">
          <div
            v-for="({ text, to, dropdown }, keyMenu) in menu"
            :key="keyMenu"
            class="d-inline-flex"
          >
            <v-btn
              v-if="!dropdown"
              class="
                text-none
                font-weight-medium
                px-2 px-lg-4
                py-5
                nav-link
                grey--text
                text--lighten-1
              "
              :to="to"
              active-class="nav-link-active"
              tile
              depressed
              text
            >
              <span class="font-bazinga">
                {{ text }}
              </span>
            </v-btn>

            <v-menu v-else offset-y tile>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  class="
                    text-none
                    font-weight-medium
                    px-2 px-lg-3
                    py-5
                    nav-link
                    grey--text
                    text--lighten-1
                  "
                  active-class="nav-link-active"
                  tile
                  depressed
                  text
                >
                  <span class="font-bazinga">
                    {{ text }}
                  </span>
                  <v-icon class="ml-3" size="12"> fa-caret-down </v-icon>
                </v-btn>
              </template>
              <v-list tile>
                <v-list-item
                  v-for="(item, keyDropdown) in dropdown"
                  :key="keyDropdown"
                  :to="item.to"
                >
                  <v-list-item-title class="grey--text text--darken-3">
                    {{ item.text }}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </div>

        <div class="d-flex justify-center justify-sm-end align-center">
          <div
            v-for="({ text, link, icon, size }, keySocial) in social"
            :key="keySocial"
            class="d-inline-flex"
          >
            <v-btn
              height="46px"
              width="46px"
              :href="link"
              :title="text"
              class="text-caption text-lg-body-1 primary--text ml-2"
              target="_blank"
              min-width="auto"
              color="primary"
              small
              depressed
              rounded
              fab
            >
              <v-icon color="white" :size="size">{{ icon }}</v-icon>
            </v-btn>
          </div>
        </div>
      </v-sheet>
    </v-container>
  </v-app-bar>
</template>

<script>
import { getTelLinkFromPhone } from "../../../utils/getTelLinkFromPhone";
import { getSocial } from "../../../utils/getSocial";

export default {
  props: {
    menu: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    social() {
      return getSocial(this.informations);
    },
    informationsContacts() {
      return this.$rest("informations-contacts").item;
    },
  },
  methods: {
    getTelLinkFromPhone,
  },
};
</script>

<style lang="scss" scoped>
.header ::v-deep {
  .nav-link-active {
    position: relative;
    &::before {
      opacity: 0 !important;
    }
    &::after {
      opacity: 1 !important;
      transform: translateX(-50%) scale(1) !important;
      transition: all 0.15s ease-in;
    }
    span {
      color: var(--v-primary-base) !important;
    }
  }
}
.nav-link {
  &::after {
    content: "";
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: var(--v-primary-base);
    position: absolute;
    left: 50%;
    top: 100%;
    transform: translateX(-50%) scale(0) !important;
    opacity: 0;
    pointer-events: none;
  }
  span {
    font-size: 18px;
    line-height: 150%;
    @media (max-width: 1264px) {
      font-size: 16px;
    }
  }
}
.header {
  &::after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 4px;
    background: linear-gradient(
      270deg,
      var(--v-primary-base) 49.22%,
      var(--v-secondary-base) 50.78%
    );
  }
}
</style>
